package com.merkost.handpass.api.dto.admin

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class PaginationMeta(
    val page: Int,
    @SerialName("page_size") val pageSize: Int,
    @SerialName("total_count") val totalCount: Long,
    @SerialName("total_pages") val totalPages: Int,
    @SerialName("sort_applied") val sortApplied: String? = null
)
